import { faCheckCircle, faGraduationCap, faGroupArrowsRotate, faLink, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import './CandidateDashboard.css';
import DashboardLayout from './DashboardLayout';
import Education from './Education';
import Experience from './Experience';
import GlobalCandidateSettings from './GlobalCandidateSettings';
import SocialProfileLinks from './SocialProfileLinks';
const Profile = () => {
  const location = useLocation();
  const userId = location.state?.userId;
  const preference = location.state?.preference;
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const [userData, setUserData] = useState();
  const navigate = useNavigate();
  const [skills, setSkills] = useState([]);
  const [showSkillsMessage, setShowSkillsMessage] = useState(false);
  const [newName, setNewName] = useState('');
  const [newPhone, setNewPhone] = useState('');
  const [dropdowns, setDropdowns] = useState({
    skills: false,
    education: false,
    experience: false,
  });
  const [educationDetails, setEducationDetails] = useState({
    degree: '',
    branch: '',
    college: '',
    percentage: ''
  });


  const [isExperience, setIsExperience] = useState(false); // Track if user selects "experience" or "fresher"
  const [originalExperience, setOriginalExperience] = useState({});
  const [errorMessage, setErrorMessage] = useState(''); // State for error message
  const [hasExperienceChanged, setHasExperienceChanged] = useState(false);

  const [formData, setFormData] = useState({
    skills: '',
    educationDetails: {},
    experience: {}
  });
  console.log(" preference --->  " + preference)
  // const [activeTab, setActiveTab] = useState('personal'); // Default tab is 'personal'
  const [activeTab, setActiveTab] = useState(preference ? preference.toLowerCase() : 'profile');


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_API_URL}/getCandidate?userId=${userId}`);
        console.log('API Response:', response.data); // Log the response to inspect it
        setUserData(response.data);
        setEducationDetails(response.data.educationDetails || {});
        setOriginalExperience(response.data.experience || {}); // Set original experience data

        const skillsArray = response.data.skills ? response.data.skills.split(',').map(skill => skill.trim()) : [];
        setSkills(skillsArray);

        setFormData({
          skills: skillsArray,
          educationDetails: response.data.educationDetails || {},
          experience: response.data.experience || {}
        });
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchData();
  }, [userId]);


  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      skills,
      educationDetails,
    }));
  }, [skills, educationDetails]);

  const toggleDropdown = (section) => {
    setDropdowns({ ...dropdowns, [section]: !dropdowns[section] });
  };

  const handleEducationChange = (e) => {
    const { name, value } = e.target;
    setEducationDetails({ ...educationDetails, [name]: value });
  };



  const [newSkill, setNewSkill] = useState('');

  const handleAddSkill = () => {
    if (newSkill && !skills.includes(newSkill)) {
      setSkills([...skills, newSkill]);
      setNewSkill(''); // Clear the input field
    }
  };

  const handleRemoveSkill = (index) => {
    setSkills(skills.filter((_, i) => i !== index));
  };

  const handleSave = async (activeTab) => {
    try {
      // Handle different cases based on active tab
      if (activeTab === 'skills') {
        if (skills.length < 5) {
          setShowSkillsMessage(true); // Show message if fewer than 5 skills
          return;
        }
      }
      else if (activeTab === 'education') {
        // Validate education fields when 'education' tab is active
        const { degree, branch, college, percentage } = educationDetails;
        if (!degree || !branch || !college || !percentage) {
          setErrorMessage('Please fill in all education details');
          return;
        } else {
          setErrorMessage(''); // Clear error message if all fields are filled
        }
      }

      // Convert skills array to a comma-separated string
      const skillsString = skills.join(', ');

      // Prepare the updated form data
      const updatedFormData = {
        skills: skillsString,
        educationDetails,  // Add education details to the form data
      };

      // Send the updated data to the backend
      await axios.put(`${BASE_API_URL}/updateCandidateDetails`, updatedFormData, {
        params: { userId }
      });

      // Success message
      toast.success("Details updated successfully!");
    } catch (error) {
      // Error handling
      console.error('Error updating user data:', error);
      toast.error('Error updating details');
    }
  };


  const toggleSettings = () => {
    navigate('/');
  };
  // Example function to simulate updating user data
  const handleEditDetails = async () => {
    // Conditionally construct the updateUrl based on which fields have changed
    let updateUrl = `${BASE_API_URL}/updateCandidate?userId=${userId}`;

    // If newName exists, append it to the URL
    if (newName) {
      updateUrl += `&newName=${newName}`;
    }

    // If newPhone exists, append it to the URL
    if (newPhone) {
      updateUrl += `&newPhone=${newPhone}`;
    }

    try {
      // Make the API call
      const response = await axios.put(updateUrl);

      // Update user data based on the response
      setUserData(response.data);
      const domain = window.location.hostname === 'localhost' ? 'localhost' : 'jobbox.one';
      document.cookie = `user=${JSON.stringify(response.data)}; path=/; domain=${domain}; secure; samesite=strict;`;

      // Clear the input fields after successful update
      setNewName('');
      setNewPhone('');
    } catch (error) {
      console.error('Error updating user data:', error);
    }
  };

  useEffect(() => {
    const savedExperienceStatus = localStorage.getItem('isExperience');
    if (savedExperienceStatus !== null) {
      setIsExperience(JSON.parse(savedExperienceStatus));
    }
  }, []);

  const customTabHeader = (title, icon) => (
    <div className="d-flex align-items-center">
      <span className="me-2">
        {/* <i className={icon} /> */}
        {icon}
      </span>
      <span class="fs-6 fw-bold">{title}</span>
    </div>
  );

  return (
    <DashboardLayout>
      <div className="main-content">
        <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: '20px' }}>
          <Col xs="auto">
            <h2 className='text-start' style={{ paddingLeft: '12px', marginBottom: 0 }}>Profile</h2>
          </Col>
          <Col xs="auto">
            <GlobalCandidateSettings userId={userId} isSomeChanges={hasExperienceChanged} />

          </Col>
        </Row>
        <Tabs
          className='profile-tabs'
          defaultActiveKey="profile" // Set the default active tab
          id="controlled-tab-example"
          activeKey={activeTab} // Control the active tab with state
          onSelect={(key) => setActiveTab(key)} // Update state on tab change
        >


          <Tab eventKey="profile" title={customTabHeader("Personal Details", <FontAwesomeIcon icon={faUser} />)} ></Tab>

          <Tab eventKey="education" title={customTabHeader("Education Details", <FontAwesomeIcon icon={faGraduationCap} />)} ></Tab>

          {/* <Tab eventKey="skills" title={customTabHeader("Skills", <FontAwesomeIcon icon={faCog} />)} ></Tab> */}

          <Tab eventKey="experience" title={customTabHeader("Experience", <FontAwesomeIcon icon={faGroupArrowsRotate} />)} ></Tab>

          {/* <Tab eventKey="experience" title={<><FaBriefcase /> Experience</>}></Tab> */}
          {/* <Tab eventKey="job preference" title={customTabHeader("Job Preference", <FontAwesomeIcon icon={faBriefcaseClock} />)} ></Tab>*/}


          <Tab eventKey="social profile links" title={customTabHeader("Social Profile Links", <FontAwesomeIcon icon={faLink} />)} ></Tab> 

        </Tabs>


        {activeTab === 'profile' && (
          <>
            <div className="candidate-profile-details">
              <h4>Personal details:</h4>
              <div className="profile-container">
                {userData && (
                  <>
                    <div className="profile-item">
                      <span className="profile-label">Name:</span>
                      <span className="profile-value">
                        {userData.userName ? (
                          userData.userName
                        ) : (
                          <>
                            <input
                              type="text"
                              value={newName}
                              onChange={(e) => setNewName(e.target.value)} // Update newName state
                              placeholder={'Enter your name'} // Show userName as placeholder
                            />
                          </>
                        )}
                      </span>
                    </div>

                    <div className="profile-item">
                      <span className="profile-label">Email:</span>
                      <span className="profile-value">
                        {userData.userEmail} <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green' }} title="Verified" />
                      </span>
                    </div>

                    <div className="profile-item">
                      <span className="profile-label">Phone Number:</span>
                      <span className="profile-value">
                        {userData.phone ? (
                          userData.phone
                        ) : (
                          <>
                            <input
                              type="text"
                              value={newPhone}
                              onChange={(e) => setNewPhone(e.target.value)} // Update newPhone state
                              placeholder="Enter your phone number" // Placeholder for phone
                            />
                          </>
                        )}
                      </span>
                    </div>

                    {/* Show "Update Details" button only if either Name or Phone is missing */}
                    {(userData.userName === null || userData.userName === '') ||
                      (userData.phone === null || userData.phone === '') ? (
                      <button onClick={handleEditDetails}>Update Details</button>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </>
        )}

        {/* Skills Tab */}
        {/* {activeTab === 'skills' && (
          <>
            <div className="candidate-profile-details">
              <h4>Skills:</h4>
              <p className="text-danger mb-3">(Note: Add at least 5 skills)</p>
              <div className="mb-3 d-flex flex-wrap">
                {skills.map((skill, index) => (
                  <span
                    key={index}
                    className="badge  text-dark me-2 mb-2 position-relative d-inline-flex align-items-center"
                    style={{
                      fontSize: '1rem',
                      padding: '0.5rem 1rem',
                      borderRadius: '0.25rem',
                      border: '1px solid grey'
                    }}
                  >
                    {skill}
                    <i
                      className="fas fa-times text-danger"
                      onClick={() => handleRemoveSkill(index)}
                      style={{
                        cursor: 'pointer',
                        fontSize: '1.2rem',
                        marginLeft: '0.5rem', // Add margin to create a gap
                      }}
                    >
                      <Delete />
                    </i>
                  </span>
                ))}
              </div>


              <div className="d-flex align-items-center">
                <input
                  type="text"
                  value={newSkill}
                  onChange={(e) => {
                    setNewSkill(e.target.value)
                    setShowSkillsMessage('')
                  }}
                  placeholder="Add a new skill"
                  className="form-control me-2"
                  style={{ width: '300px' }}
                />
                <Button variant="primary" onClick={handleAddSkill}><FaPlus /></Button>
              </div>
              {showSkillsMessage && (
                <p className="text-danger mt-3">Please add at least 5 skills.</p>
              )}
            </div>
          </>
        )} */}


        {/* Education Details Tab */}
        {activeTab === 'education' && (
          <>
            <Education userId={userId} />
          </>
        )}

        {/* Experience Section */}
        {activeTab === 'experience' && (
          <div className="candidate-profile-details">
            <Experience
              userId={userId}
              hasExperienceChanged={hasExperienceChanged}
              setHasExperienceChanged={setHasExperienceChanged}
            />
          </div>
        )}


        {/* Job prefrence Tab */}
        {/* {activeTab === 'job preference' && (
          <>
            <div className="candidate-profile-details">
              <Jobpreference userId={userId} />
            </div>
          </>
        )
        } */}

        {/* Social Profile Links Tab */}
        {activeTab === 'social profile links' && (
          <>
            <SocialProfileLinks state={{ userId: userId }} />
          </>
        )}

        <div className="d-flex justify-content-center mt-3">
          {['skills'].includes(activeTab) && (
            <Button variant="primary" onClick={() => handleSave(activeTab)}>
              Save
            </Button>
          )}
        </div>




        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
        <br></br>
      </div >
    </DashboardLayout >
  );
};
export default Profile;
